import React from 'react'

import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import { Title } from '../../../packages/kiti/components/presentation/Text'
import { useCloseModal } from '../../../components/modals/ModalsContext'
import Icon from '../../../packages/kiti/components/shapes/Icon'
import Line from '../../../packages/kiti/components/helpers/Line'
import Separator from '../../../packages/kiti/components/helpers/Separator'

const ModalHeader = () => {
  const closeModal = useCloseModal()

  return (
    <>
      <Grid justify="space-between" align="center">
        <Col flex={1}>
          <Title size="h5" bold>
            Editando campos adicionais
          </Title>
        </Col>
        <Col>
          <Icon name="BsX" size={2} onClick={closeModal} color="dark3" />
        </Col>
      </Grid>

      <Separator weight={2} />
      <Line />
    </>
  )
}

export default ModalHeader
